import { render, staticRenderFns } from "./quesDetail.vue?vue&type=template&id=11fdd14b"
import script from "./quesDetail.vue?vue&type=script&lang=js"
export * from "./quesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports